import { default as unsubscribewD5HDc7KXUMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/pages/unsubscribe.vue?macro=true";
import { default as page29nyNpkz9TMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/storyblok/page?macro=true";
import { default as headers_45testO7ROx0hBpjMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/storyblok/headers-test?macro=true";
import { default as homepagejUML27pLA2Meta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/homepage?macro=true";
import { default as article1mEvj1VYoQMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/article?macro=true";
import { default as document_45patternsCxTIf2KbElMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/document-patterns?macro=true";
import { default as tagF30tmAL20KMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/tag?macro=true";
import { default as autorFZ6dV5IPHlMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/autor?macro=true";
import { default as categoryLep6XaS6R8Meta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/category?macro=true";
import { default as sectionwMF3w5eDJkMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/section?macro=true";
import { default as all_45articles9tEuw1JSmHMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/all-articles?macro=true";
import { default as categorydUD4tMBj3YMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/glossary-of-terms/category?macro=true";
import { default as articletPYTCFomhrMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/glossary-of-terms/article?macro=true";
import { default as sectionmRPc8JTH2oMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/adviser/section?macro=true";
import { default as complaintXTYuqxfcBQMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/complaint?macro=true";
import { default as price_45guaranteeCrna48bgkNMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/price-guarantee?macro=true";
import { default as contactgCDfkjskP4Meta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/contact?macro=true";
import { default as car_45insurance_45terminationGFHnoZa68MMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/car-insurance-termination?macro=true";
import { default as zadostYygHwnwCeHMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/loans/pages/loans/uniform/zadost?macro=true";
import { default as thankwbBpJzrDLWMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/loans/pages/loans/uniform/thank?macro=true";
import { default as srovnanilwCb5DZpvRMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani?macro=true";
import { default as calculationBYq0WejirvMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/calculation?macro=true";
import { default as offer_45listdcdeAzxbbbMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/offer-list?macro=true";
import { default as thank_45youFbqDNctS6GMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/thank-you?macro=true";
import { default as inquiry_45onlineBfBg7xAiXxMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/inquiry-online?macro=true";
import { default as detailuDarHvrZlrMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/detail?macro=true";
import { default as inquiry_45phonescSepjzsSQMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/inquiry-phone?macro=true";
import { default as inquiry_45custom_45offeroZo6MApgasMeta } from "/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/inquiry-custom-offer?macro=true";
export default [
  {
    name: "unsubscribe",
    path: "/unsubscribe",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/pages/unsubscribe.vue")
  },
  {
    name: page29nyNpkz9TMeta?.name,
    path: "/:all(.*)*",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: headers_45testO7ROx0hBpjMeta?.name,
    path: "/headers-test",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/storyblok/headers-test")
  },
  {
    name: homepagejUML27pLA2Meta?.name,
    path: "/aktuality",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/homepage")
  },
  {
    name: article1mEvj1VYoQMeta?.name,
    path: "/aktuality/:article(.*)*",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/article")
  },
  {
    name: document_45patternsCxTIf2KbElMeta?.name,
    path: "/aktuality/vzory-dokumentu",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/document-patterns")
  },
  {
    name: tagF30tmAL20KMeta?.name,
    path: "/aktuality/tag/:slug(.*)*",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/tag")
  },
  {
    name: autorFZ6dV5IPHlMeta?.name,
    path: "/aktuality/autor/:slug(.*)*",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/autor")
  },
  {
    name: categoryLep6XaS6R8Meta?.name,
    path: "/aktuality/:category(pojisteni)",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/category")
  },
  {
    name: sectionwMF3w5eDJkMeta?.name,
    path: "/aktuality/:category(pojisteni)/:section(auto|cestovani|zivot|dum-a-domacnost)",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/section")
  },
  {
    name: all_45articles9tEuw1JSmHMeta?.name,
    path: "/aktuality/all-articles",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/blog/all-articles")
  },
  {
    name: page29nyNpkz9TMeta?.name,
    path: "/slovnik-pojmu",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/storyblok/page")
  },
  {
    name: categorydUD4tMBj3YMeta?.name,
    path: "/slovnik-pojmu/:category(pojisteni)",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/glossary-of-terms/category")
  },
  {
    name: articletPYTCFomhrMeta?.name,
    path: "/slovnik-pojmu/:category(pojisteni)/:id(.*)*",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/glossary-of-terms/article")
  },
  {
    name: sectionmRPc8JTH2oMeta?.name,
    path: "/radce/",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: sectionmRPc8JTH2oMeta?.name,
    path: "/radce/:slug(.*)",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/adviser/section")
  },
  {
    name: complaintXTYuqxfcBQMeta?.name,
    path: "/reklamace",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/complaint")
  },
  {
    name: price_45guaranteeCrna48bgkNMeta?.name,
    path: "/garance-nejnizsi-ceny",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/price-guarantee")
  },
  {
    name: contactgCDfkjskP4Meta?.name,
    path: "/kontakt",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/contact")
  },
  {
    name: car_45insurance_45terminationGFHnoZa68MMeta?.name,
    path: "/zruseni-povinne-ruceni",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/storyblok/pages/forms/car-insurance-termination")
  },
  {
    name: zadostYygHwnwCeHMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/zadost",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/loans/pages/loans/uniform/zadost")
  },
  {
    name: thankwbBpJzrDLWMeta?.name,
    path: "/pujcky-a-uvery/:provider(zaplo-online-pujcka|zaplo-na-splatky-online-pujcka|home-credit-online-pujcka|csob-online-pujcka|komercni-banka-pujcka|ceska-sporitelna|kamali)/:thank(dekujeme|zamitnuto-partner|zamitnuto)",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/loans/pages/loans/uniform/thank")
  },
  {
    name: srovnanilwCb5DZpvRMeta?.name,
    path: "/pujcky-a-uvery/pujcka-na-miru/srovnani",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/loans/pages/loans/pujcka-na-miru/srovnani")
  },
  {
    name: calculationBYq0WejirvMeta?.name,
    path: "/energie/kalkulace-:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/calculation")
  },
  {
    name: offer_45listdcdeAzxbbbMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/offer-list")
  },
  {
    name: thank_45youFbqDNctS6GMeta?.name,
    path: "/energie/prehled-vaseho-pozadavku/:leadId?",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/thank-you")
  },
  {
    name: inquiry_45onlineBfBg7xAiXxMeta?.name,
    path: "/energie/sjednani-online/:vertical(elektrina|plyn)/:leadId?",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/inquiry-online")
  },
  {
    name: detailuDarHvrZlrMeta?.name,
    path: "/energie/srovnani-nabidek/:vertical(plyn|elektrina)/:leadId/detail/:tariffId",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/detail")
  },
  {
    name: inquiry_45phonescSepjzsSQMeta?.name,
    path: "/energie/sjednani-po-telefonu/:vertical(plyn|elektrina)/:leadId?",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/inquiry-phone")
  },
  {
    name: inquiry_45custom_45offeroZo6MApgasMeta?.name,
    path: "/energie/nabidka-na-miru",
    component: () => import("/codebuild/output/src670093298/src/nuxt-epojisteni/.srovnejto/energo/pages/inquiry-custom-offer")
  }
]